<template> 
   <div class="container-reclef">
 <TopoSlot></TopoSlot>
    <p style="color: #000;font-size:25px;font-weight:700;margin: 65px 50px 25px 50px;">Qual regime tributário a empresa analisada está inserida?</p>    
      
        <div class="blocos">
            <blocoInput txt="Lucro Real" valor="1" idRadio="1"  style="margin-top:40px;"/>
            <blocoInput txt="Lucro Presumido" valor="2" idRadio="2"  style="margin-top:60px;"/>
        </div>
        <div style="display: flex; align-items: center; justify-content: center;flex-direction: column;margin-top: 30px;">
            <button class="continue-button" @click="continuar">Continuar</button>
        </div>    
</div>
     
</template>
    
<script>
import blocoInput from '../components/blocoInput.vue'
export default {
  components: {blocoInput}, 
    methods:{      
        continuar(){
            let inputs = document.querySelectorAll('input[name="options"]')
             if(inputs[0].checked || inputs[1].checked){       
                if(inputs[0].checked){
                    this.$store.state.regimeTributario = 1
                }else{
                    this.$store.state.regimeTributario = 2
                }
                this.$router.push({name:'importar'})                 
             }   
        }
    }
    

}
</script>

<style>
.nota {
    width: 100%;
    background: #fff3cd;
    border: 1px solid #ffeeba;
    margin: 15px 0;
    max-width: 825px;
}
.nota p {
    margin: 0!important;
    font-size: 15px!important;
    color: #212529!important;
    padding: 10px;
    font-weight: 700!important;
    text-align: justify;
}
.blocos{
    display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
}

.radio-component>input:active+label>.input-box, .radio-component>input:checked+label>.input-box, .radio-component>input:focus+label>.input-box {
    background: #af3437!important;
    background-image: none!important; 
    box-shadow: none!important;
}
.large-bar-radio {
    margin: 0 0 0 20px;
}
.radio-component>input {
    opacity: 0;
    position: absolute;
}
.radio-component>input:checked+label>.input-box>.input-box-circle {
    opacity: 1;
    margin: 22%;
    width: 56%;
    height: 56%;
}
label{
    margin-bottom: 0px;
}
.radio-component>input+label>.input-box>.input-box-circle {
    display: block;
    margin: 50%;
    width: 0;
    height: 0%;
    background: #fff;
    border-radius: 50%;
    opacity: 0;
    transition: width .15s ease-in,height .15s ease-in,margin .15s ease-in;
}
.radio-component>input+label>.input-box {
    display: inline-block;
    border: 1px solid #000;
    border-radius: 50%;
    margin: 0;
    padding: 0;
    width: 1em;
    height: 1em;
    background: #fff;
    overflow: hidden;
    vertical-align: -5%;
    user-select: none;
}

.radio-component>input+label>.input-box {
    border-color: #af3437!important;
    background: #fff!important;
}
.large-bar p{
font-size: 14px;
 margin: 0px 0px 0px 20px; 
 font-weight: 700; 
 color: rgb(56, 56, 56); 
 line-height: 15px;
}
.blocos{
    display: flex;   
    justify-content: center;
}
.large-bar {    
    display: flex;
    align-items: center;  
    justify-content: flex-start;
    min-height: 70px!important;
    max-height: 300px!important;
    height: 100px!important;
    background: #eee;
    max-width: 600px;
    width: 100%;
    border-radius: 5px;   
    transition: all .2s;
    border-left: 10px solid #af3437;
}
#cnpj-reclef{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
}
#cnpj-reclef p{
    text-align: center; 
    font-size: 18px; 
    color: rgb(0, 0, 0); 
    font-weight: bold;
    margin-bottom: 0;
}
#cnpj-reclef input{
    border-radius: 10px;
    min-height: 35px;
    border: 1px solid #707070;
    max-width: 380px;
    width: 100%;
    padding-left: 10px;
    font-size: 13px;
}
#cnpj-reclef button{
    width: 100%;
    max-width: 130px;
    height: 40px;
    background: #af3437;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
}
.continue-button{
margin-top: 40px;
    width: 150px;
    height: 40px;
    background: #af3437;
    color: #fff;
    font-size: 15px;
    font-style: italic;
    border-radius: 5px;
    margin-bottom:50px;
}
</style>